module.exports = __webpack_public_path__ + "static/media/home_1.d764aa58.PNG";